(function($){

    // Top Section Control
    $( '.location-list a' ).on( 'click', function(e){
        
        e.preventDefault();
        
        let index = $( this ).attr( 'data-index' );
        $( '.location-list a.active' ).removeClass( 'active' );
        $( this ).addClass( 'active' );

        let $single_block = $( '.location-details-right' ).find( '.location-details-single[data-index="'+ index +'"]' );
        $( '.location-details-right' ).find( '.location-details-single.active' ).removeClass( 'active' );
        $single_block.addClass( 'active' );

        let loc = { lat: $single_block.attr( 'data-lat' ), lng: $single_block.attr( 'data-lng' ) };
        init_leaflet_map( loc );

        let location_name = $.trim( $( this ).html() );
        console.log( location_name );
        $( 'select[name="input_9"]' ).val( location_name );
        $( 'select[name="input_9"]' ).trigger( 'change' );

    });

    const init_leaflet_map = ( loc ) => {
        map.setView([loc.lat, loc.lng], 15);
        L.marker([loc.lat, loc.lng], { icon: icon }).addTo(map);
    }

    const map = L.map( 'location-map' );
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19
    }).addTo(map);
    const icon = L.icon({
        iconUrl: $('#location-map').attr( 'data-marker' ),
        iconSize: [25, 40],
        // iconAnchor: [22, 94],
    });
    let $start_active = $( '.location-details-right .location-details-single.active' )
    let loc = { lat: $start_active.attr( 'data-lat' ), lng: $start_active.attr( 'data-lng' ) };
    init_leaflet_map( loc );

})( jQuery );